import React, { useEffect, useState } from 'react';
import { Container, Grid, CircularProgress, Snackbar, Alert } from '@mui/material';
import axios from 'axios';
import RequestUserCard from './RequestUserCard';
import UserActivityTracker from './UserActivityTracker';

const API_URL = process.env.REACT_APP_API_URL;

const RequestUsersList = ({ userId, loggedIn, onLogout }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);

  
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${API_URL}/get_users/`);
        setUsers(response.data);
      } catch (error) {
        setError('Failed to fetch users. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  // Update the user's status when receiving WebSocket updates
  const updateUserStatus = (userId, status) => {
    setUsers((prevUsers) =>
      prevUsers.map((user) =>
        user.id === userId ? { ...user, online: status === 'online' } : user
      )
    );
  };

  return (
    <Container>
      {loading ? (
        <CircularProgress sx={{ display: 'block', margin: '50px auto' }} />
      ) : (
        <Grid container spacing={4} justifyContent="center">
          {users.map((user) => (
            <Grid item xs={12} sm={6} md={4} key={user.id}>
              {/* Integrate UserActivityTracker for real-time updates */}
              <UserActivityTracker userId={user.id} onStatusChange={updateUserStatus} />
              <RequestUserCard user={user} />
            </Grid>
          ))}
        </Grid>
      )}

      {/* Snackbar for error messages */}
      {error && (
        <Snackbar open={Boolean(error)} autoHideDuration={6000} onClose={() => setError(null)}>
          <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default RequestUsersList;
